import {getId, getType} from 'apis/model/base'
import {FollowButton} from 'components/Feed/FollowButton'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import numeral from 'numeral'
import React, {useContext, useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import getTitle from "../../../helpers/getTitle";
import {FaWandMagicSparkles} from "react-icons/fa6";
import getLinkToDetail from 'helpers/getLinkToDetail'
import {bindQueryParams} from "../../AppLocals/functions/routerHelper";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";
import useAsyncAction from "../../../modules/asyncCache/useAsyncAction";
import {formatSimplifyDate} from "../../../helpers/dateUtils";
import {BiMessageSquareDetail} from "react-icons/bi";
import {feed_fetchFeedByContainer_Api} from "../../../apis";
import {GoDotFill} from "react-icons/go";
import {RiSignalTowerFill} from "react-icons/ri";
import classNames from "classnames";


const ArticleLink = ({item, title, commentCount}) => (
    <div className="flex flex-col leading-relaxed max-lines-3">
        <Link to={getLinkToDetail(item)} className="flex items-center text-gray-700 no-underline max-lines-3">
            <div className="space-x-1 items-start">
                <GoDotFill size={10} className="text-color-500"/>
                <span className="font-medium leading-snug">
                    {title}
                </span>
            </div>
        </Link>
        <div className="flex items-center gap-4 ">
            {commentCount > 0 && (
                <div className="flex items-center gap-1 text-xs">
                    <BiMessageSquareDetail size={12} className="text-color-400"/>
                    <span className="text-gray-600">{commentCount}</span>
                </div>
            )}
        </div>
    </div>
);

const ChannelItem = ({item, style}) => {
    const t = useTranslate()
    const type = getType(item);
    const id = getId(item);
    const {isLg} = useContext(LayoutContext)
    const [data, setData] = useState([])

    const {handleAsyncAction} = useAsyncAction({
        apiInfo: feed_fetchFeedByContainer_Api,
        query: bindQueryParams([{id: id}, {prop: type}]),
        onSuccess: (result, data) => {
            const _data = _.get(data, 'response.data.data', [])
            setData(_data)
        },
    })
    useEffect(() => {
        handleAsyncAction()
    }, [])

    const featured = _.first(data);
    const secondaryLinks = _.tail(data);

    if (!item) return null

    return (
        <div style={style}
             className="background hover:shadow-md hover:scale-2xs rounded-xl relative">
            <div
                className={classNames(
                    "border-b background-200 p-3",
                    !!featured ? 'mb-4 pb-2 rounded-t-xl' : 'rounded-xl'
                )}>
                <h2 className="space-x-2">
                    <RiSignalTowerFill />
                    <Link
                        to={getLinkToDetail(item)}
                        className="font-bold text-lg text-color-000 tracking-wide no-underline">
                        {getTitle(item)}
                    </Link>
                </h2>
                <div className="flex items-center gap-2">
                    {item.total_followers && item.total_followers > 0 && (
                        <span className="text-xs md:text-sm text-color-100 italic tracking-wider lowercase">
                            <strong>{numeral(item.total_followers).format()}</strong> {t('followers')}
                        </span>
                    )}
                    {!!_.get(item, 'selected_by_editor') && (
                        <span className="h-6 px-2 py-1 flex flex-center gap-1 font-medium text-xs text-blue-600 bg-blue-100 tracking-wide rounded-full">
                            <FaWandMagicSparkles size={10}/>
                            {!!isLg && t("editor's choice")}
                        </span>
                    )}
                    <div className="flex-1"/>
                    <FollowButton
                        size="small"
                        item={item}
                        className="text-sm"
                    />
                </div>
            </div>
            {!!featured && (
                <div className="flex flex-col gap-3 p-3">
                    {/* Featured Section based on Image 2 */}
                    <div className="flex gap-4">
                        {!!featured?.content?.overview?.photo && (
                            <div className="w-24 h-20 flex-shrink-0 rounded-lg overflow-hidden border border-gray-100">
                                <img
                                    src={featured?.content?.overview?.photo}
                                    alt={featured?.content?.title || featured?.content?.overview?.title || featured?.content?.overview?.description}
                                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                                />
                            </div>
                        )}
                        <div className="flex flex-col flex-1 min-w-0">
                            <Link to={getLinkToDetail(featured?.content)}
                                  className="max-lines-2 font-bold text-lg text-gray-800 no-underline">
                                <h3 className="leading-tight">
                                    {featured?.content?.title || featured?.content?.overview?.title || featured?.content?.overview?.description}
                                </h3>
                            </Link>
                            <div className="space-x-2 text-xs tracking-wide">
                            <span
                                className="text-color-300 italic">{formatSimplifyDate(featured?.content?.created, 'fullTime')}</span>
                                <GoDotFill size={8} className="text-color-500"/>
                                <span className="font-semibold text-gray-600 italic">
                                    {getTitle(featured?.content?.owner)}
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Secondary Links based on Image 1 & 2 */}
                    {secondaryLinks?.length > 0 && (
                        <div className="py-2 flex flex-col space-y-3">
                            {secondaryLinks.map((link, idx) => (
                                <ArticleLink key={idx}
                                             item={link?.content}
                                             title={link?.content?.title || link?.content?.overview?.title || link?.content?.overview?.description}
                                             commentCount={link?.content?.total_comments}/>
                            ))}
                        </div>
                    )}

                    {/* Footer / See More */}
                    <div className="mt-4 flex justify-end">
                        <Link to={getLinkToDetail(item)}
                              className="space-x-1 font-semibold text-xs text-secondary-600 hover:text-blue-600 tracking-wide no-underline">
                            {`${t("go to channel")}: `} <label className="italic">{getTitle(item)}</label>
                        </Link>
                    </div>
                </div>
            )}
        </div>
    )
}

export const renderChannelItem = (item) => (
    <ChannelItem
        item={item}
        key={getId(item)}
    />
)


const ChannelItemList = ({item, style}) => {
    const t = useTranslate()
    const type = getType(item);
    const id = getId(item);
    const {isLg} = useContext(LayoutContext)
    const [data, setData] = useState([])

    const {handleAsyncAction} = useAsyncAction({
        apiInfo: feed_fetchFeedByContainer_Api,
        query: bindQueryParams([{id: id}, {prop: type}]),
        onSuccess: (result, data) => {
            const _data = _.get(data, 'response.data.data', [])
            setData(_data)
        },
    })
    useEffect(() => {
        handleAsyncAction()
    }, [])

    const featured = _.first(data);
    const secondaryLinks = _.tail(data);

    if (!item) return null

    return (
        <div style={style} className="border-b border-color-50 background shadow-md hover:scale-3xs rounded-xl relative">
            <div
                className={classNames(
                    "border-b background-200 p-3",
                    !!featured ? 'pb-2 rounded-t-xl' : 'rounded-xl'
                )}>
                <h2 className="space-x-2">
                    <RiSignalTowerFill />
                    <Link
                        to={getLinkToDetail(item)}
                        className="font-bold text-lg text-color-000 tracking-wide no-underline">
                        {getTitle(item)}
                    </Link>
                </h2>
                <div className="flex items-center gap-2">
                    {item.total_followers && item.total_followers > 0 && (
                        <span className="text-xs md:text-sm text-color-100 italic tracking-wider lowercase">
                            <strong>{numeral(item.total_followers).format()}</strong> {t('followers')}
                        </span>
                    )}
                    {!!_.get(item, 'selected_by_editor') && (
                        <span className="h-6 px-2 py-1 flex flex-center gap-1 font-medium text-xs text-blue-600 bg-blue-100 tracking-wide rounded-full">
                            <FaWandMagicSparkles size={10}/>
                            {!!isLg && t("editor's choice")}
                        </span>
                    )}
                    <div className="flex-1"/>
                    <FollowButton
                        size="small"
                        item={item}
                        className="text-sm"
                    />
                </div>
            </div>
            {!!featured && (
                <div className="flex flex-col gap-4 p-3">
                    {/* Featured Section based on Image 2 */}
                    <div className="flex gap-4">
                        {!!featured?.content?.overview?.photo && (
                            <div className="w-24 h-20 flex-shrink-0 rounded-lg overflow-hidden border border-gray-100">
                                <img
                                    src={featured?.content?.overview?.photo}
                                    alt={featured?.content?.title || featured?.content?.overview?.title || featured?.content?.overview?.description}
                                    className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                                />
                            </div>
                        )}
                        <div className="flex flex-col flex-1 min-w-0">
                            <Link to={getLinkToDetail(featured?.content)}
                                  className="max-lines-2 font-bold text-lg text-gray-800 no-underline">
                                <h3 className="leading-tight">
                                    {featured?.content?.title || featured?.content?.overview?.title || featured?.content?.overview?.description}
                                </h3>
                            </Link>
                            <div className="space-x-2 text-xs tracking-wide">
                            <span
                                className="text-color-300 italic">{formatSimplifyDate(featured?.content?.created, 'fullTime')}</span>
                                <GoDotFill size={8} className="text-color-500"/>
                                <span className="font-bold text-gray-700">{getTitle(featured?.content?.owner)}</span>
                            </div>
                        </div>
                    </div>

                    {/* Secondary Links based on Image 1 & 2 */}
                    {secondaryLinks?.length > 0 && (
                        <div className="py-2 flex flex-col space-y-3">
                            {secondaryLinks.slice(0,2).map((link, idx) => (
                                <ArticleLink key={idx}
                                             item={link?.content}
                                             title={link?.content?.title || link?.content?.overview?.title || link?.content?.overview?.description}
                                             commentCount={link?.content?.total_comments}/>
                            ))}
                        </div>
                    )}

                    {/* Footer / See More */}
                    <div className="mt-2 flex justify-end">
                        <Link to={getLinkToDetail(item)}
                              className="space-x-1 font-semibold text-xs text-secondary-600 tracking-wide no-underline">
                            {`${t("go to channel")}: `}
                            <label className="italic cursor-pointer">{getTitle(item)}</label>
                        </Link>
                    </div>
                </div>
            )}
        </div>
    )
}

export const renderChannelItemList = (item) => (
    <ChannelItemList
        item={item}
        key={getId(item)}
    />
)